<template>
  <TheTemplateM
    class="p-the-page-m11"
    :is-simple-header="true"
    :step="step"
    :step-options="stepOptions"
  >
    <template #heading>メールアドレス変更</template>

    <template #body>
      <div class="p-the-page-m11__message c-form-inner--wide">
        <p class="p-the-page-m11__message__text">
          メールアドレスの変更が完了しました。
        </p>

        <div class="p-form-button-group">
          <div class="p-form-button-group__vertical">
            <ButtonMain :tag="'a'" href="/">ログインする</ButtonMain>
          </div>
        </div>
      </div>
    </template>
  </TheTemplateM>
</template>

<script lang="ts">
import TheTemplateM from "@/general/components/templates/TheTemplateM.vue";
import ButtonMain from "@/common/components/atoms/ButtonMain.vue";
import { Options, Vue } from "vue-class-component";

import commons from "@/common/store/modules/commons";
import AuthStorage from "@/general/utils/auth";

@Options({
  components: {
    TheTemplateM,
    ButtonMain
  }
})
export default class MyPageEmailSettingsDone extends Vue {
  step = 4;
  stepOptions: any = [
    { step: 1, label: "入力" },
    { step: 2, label: "メール確認" },
    { step: 3, label: "本人認証" },
    { step: 4, label: "完了" }
  ];

  breadcrumb = [
    {
      text: "",
      url: "/home",
      pageType: "home"
    },
    {
      text: "マイページ",
      url: "/my-page/",
      pageType: "lower"
    },
    {
      text: "メールアドレス変更",
      url: "",
      pageType: "lower"
    }
  ];

  mounted() {
    AuthStorage.checkLogin();
  }

  created() {
    commons.getBreadcrumb(this.breadcrumb);
  }
}
</script>

<style lang="scss" scoped>
.p-the-page-m11 {
  &__message {
    margin-top: rem(48);

    @include sp {
      margin-top: rem(36);
    }

    &__text {
      // TODO: irregular
      color: #4f4f4f;
      font-size: rem(20);
      font-weight: bold;
      line-height: (27/20);
      text-align: center;

      @include sp {
        font-size: rem(16);
      }

      & + & {
        margin-top: em(1.5);
      }
    }
  }
}
</style>
